export const GET_CROSS_CHAIN = 'GET_CROSS_CHAIN'
